import { DepartureHit } from "@wojo/services";
import { minBy } from "lodash";
import { useTourPageContext } from "../../../_client/context";
import { PaymentScheduleFrequency } from "../../../../generated/graphql";

export const useLowestEstimatedPayment = (departureHits: DepartureHit[]) => {
    const { defaultPaymentFrequency } = useTourPageContext();

    const lowestEstimatedBiweeklyPayment = minBy(
        departureHits,
        (departure) => departure.estimatedBiweeklyPayment,
    )?.estimatedBiweeklyPayment;
    const lowestEstimatedMonthlyPayment = minBy(
        departureHits,
        (departure) => departure.estimatedMonthlyPayment,
    )?.estimatedMonthlyPayment;

    return defaultPaymentFrequency === PaymentScheduleFrequency.Biweekly
        ? lowestEstimatedBiweeklyPayment
        : lowestEstimatedMonthlyPayment;
};
